import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { BcSalesOrder } from "src/api-service";
import { AppError } from "../../app-store-error.types";

// **************************************************************************
// SALES ORDER DETAIL ACTIONS
// **************************************************************************

export const SalesOrderActions = createActionGroup({
    source: "Sales Order",
    events: {
        "Load": props<{ orderNumber: string }>(),
        "Load Success": props<{ salesOrder: BcSalesOrder; toastKey: string }>(),
        "Load Failure": props<{ error: AppError; toastKey: string }>(),
        "Reset": emptyProps(),
        "Clear Error": emptyProps(),
    },
});
